<style scope>
</style>

<template>
  <section class="container">

    <portal-box style="min-height: 600px">
      <h1 slot="titulo" class="title">
        <b-field>
          <b-radio-button v-model="tipoSelecionado"
                          native-value="comissaoReceber"
                          type="is-primary">
            <span>Comissão a Receber (já baixados)</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado"
                          native-value="comissaoSintetica"
                          type="is-primary">
            <span>Comissão Sintética</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado"
                          native-value="comissaoAnalitica"
                          type="is-primary">
            <span>Comissão Analítica</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado"
                          native-value="comissaoPrevista"
                          type="is-primary">
            <span>Comissão Prevista (não baixados)</span>
          </b-radio-button>

        </b-field>
      </h1>

      <template v-if="tipoSelecionado === 'comissaoReceber'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="Pedido">
            <b-input v-model="filtro.pedido" placeholder="código do pedido"/>
          </b-field>

          <b-field label="Código do cliente">
            <b-input v-model="filtro.clienteCodigo" placeholder="código"/>
          </b-field>

          <b-field label="Nome do cliente">
            <b-input v-model="filtro.clienteNome" placeholder="razão social"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Vencimento</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.vencimentoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.vencimentoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Liquidação</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.liquidacaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.liquidacaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.liquidacaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.liquidacaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total a Receber: {{valorTotalComissao | moeda}}</b-tag>
      </template>

      <template v-if="tipoSelecionado === 'comissaoSintetica'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="Ano">
            <b-input v-model="filtro.ano"/>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
      </template>

      <template v-if="tipoSelecionado === 'comissaoAnalitica'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="Pedido">
            <b-input v-model="filtro.pedido" placeholder="código do pedido"/>
          </b-field>

          <b-field label="Código do cliente">
            <b-input v-model="filtro.clienteCodigo" placeholder="código"/>
          </b-field>

          <b-field label="Nome do cliente">
            <b-input v-model="filtro.clienteNome" placeholder="razão social"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Vencimento</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.vencimentoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.vencimentoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Liquidação</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.liquidacaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.liquidacaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.liquidacaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.liquidacaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>

        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{valorTotalComissao | moeda}}</b-tag>
      </template>

      <template v-if="tipoSelecionado === 'comissaoPrevista'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="Pedido">
            <b-input v-model="filtro.pedido" placeholder="código do pedido"/>
          </b-field>

          <b-field label="Código do cliente">
            <b-input v-model="filtro.clienteCodigo" placeholder="código"/>
          </b-field>

          <b-field label="Nome do cliente">
            <b-input v-model="filtro.clienteNome" placeholder="razão social"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Vencimento</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.vencimentoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.vencimentoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>
        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{valorTotalComissaoPrevista | moeda}}</b-tag>
      </template>


      <comissao-receber :valorTotal="valorTotalComissao" :lista="lista" :loading="loading"
                        v-if="tipoSelecionado === 'comissaoReceber'"></comissao-receber>

      <comissao-sintetica :lista="lista" :loading="loading" v-if="tipoSelecionado === 'comissaoSintetica'"></comissao-sintetica>

      <comissao-analitica :valorTotal="valorTotalComissao" :lista="lista" :loading="loading" v-if="tipoSelecionado === 'comissaoAnalitica'"></comissao-analitica>

      <comissao-prevista :valorTotal="valorTotalComissaoPrevista" :lista="lista" :loading="loading" v-if="tipoSelecionado === 'comissaoPrevista'"></comissao-prevista>

    </portal-box>
  </section>
</template>

<script>
  import { mask } from 'vue-the-mask'
import { listagem } from '../../mixins/listagem'
import ComissaoAnalitica from './ListaComissaoAnalitica'
import ComissaoPrevista from './ListaComissaoPrevista'
import ComissaoReceber from './ListaComissaoReceber'
import ComissaoSintetica from './ListaComissaoSintetica'

  export default {
    directives: {mask},
    components: {ComissaoReceber, ComissaoSintetica, ComissaoAnalitica, ComissaoPrevista},
    mixins: [listagem],
    created () {
      this.metodo = 'PUT'
      this.tipoSelecionado = 'comissaoReceber'
      this.filtrarSelecionado()
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/comissao').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    data () {
      return {
        tipoSelecionado: ''
      }
    },
    methods: {
      filtrarSelecionado () {
        this.lista = []
        if (this.tipoSelecionado === 'comissaoReceber') {
          this.url = this.$URL.COMISSAO.RECEBER
        } else if (this.tipoSelecionado === 'comissaoSintetica') {
          this.url = this.$URL.COMISSAO.SINTETICA
        } else if (this.tipoSelecionado === 'comissaoAnalitica') {
          this.url = this.$URL.COMISSAO.ANALITICA
        } else {
          this.url = this.$URL.COMISSAO.PREVISTA
        }
        this.filtrar()
      },
      limparFiltro () {
        this.filtro = {}
        if (this.tipoSelecionado === 'comissaoReceber') {
          this.url = this.$URL.COMISSAO.RECEBER
        } else if (this.tipoSelecionado === 'comissaoSintetica') {
          this.url = this.$URL.COMISSAO.SINTETICA
        } else if (this.tipoSelecionado === 'comissaoAnalitica') {
          this.url = this.$URL.COMISSAO.ANALITICA
        } else {
          this.url = this.$URL.COMISSAO.PREVISTA
        }
        this.filtrar()
      }
    },
    watch: {
      tipoSelecionado (value) {
        this.lista = []
        this.limparFiltro()
      }
    },
    computed: {
      valorTotalComissao () {
        let valor = 0
        if (this.lista.length > 0) {
          this.lista.forEach(c => {
            valor = valor + parseFloat(c.E3_COMIS)
          })
        }
        return parseFloat(valor).toFixed(2)
      },

      valorTotalComissaoPrevista () {
        let valor = 0
        if (this.lista.length > 0) {
          this.lista.forEach(c => {
            valor = valor + parseFloat(c.COMIS)
          })
        }
        return parseFloat(valor).toFixed(2)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/comissao/Lista.vue